module.exports = __webpack_public_path__ + "img/dep_alcoholicbeverage@2x.ec5038da.png";